import React from "react";

import PasoPromocion from "../../navigation/v2/managment/enrollmentRequests/pasoPromocion";
import { RequestPromotionDTO, RequestPromotionItemDTO } from "../../models/EnrollmentHistoryDTO";

/*
	A1 (cobros, Esteban 2026-10-08): matricular desde Horarios, desde el perfil o al dar de alta a un alumno también lleva el
	paso Promoción de la solicitud («Ninguna» explícita vale). Es el mismo componente (elegibilidad en vivo, tira de meses,
	«¿con quién?»); el servidor lo vuelve a revisar todo al matricular y, si no cuadra, no matricula.
*/

export const promoVacia = (): RequestPromotionDTO => ({ items: [] });

/** ¿Falta elegir la promoción de algún curso? */
export const faltaPromo = (v: RequestPromotionDTO | undefined | null, scheduleIds: number[]): boolean =>
	scheduleIds.some((sid) => {
		const it = (v?.items || []).find((i) => i.scheduleId === sid);
		return !it || it.promotionId === null || it.promotionId === undefined;
	});

/**
	Perfil / alta: cada curso se matricula en su propia llamada. Si un curso va «con su otro curso» (50 % o 2x1), el otro se
	matricula primero y el vínculo se manda como la matrícula que ya quedó creada.
*/
export const ordenPorAncla = (scheduleIds: number[], v: RequestPromotionDTO): number[] => {
	const ancla = (sid: number): number | null => {
		const l = (v.items || []).find((i) => i.scheduleId === sid)?.link;
		return l && l.type === "solicitud" && l.scheduleId && scheduleIds.includes(Number(l.scheduleId)) ? Number(l.scheduleId) : null;
	};
	const out: number[] = [];
	const visitar = (sid: number, profundidad: number) => {
		if (out.includes(sid) || profundidad > scheduleIds.length) return;
		const a = ancla(sid);
		if (a !== null && a !== sid) visitar(a, profundidad + 1);
		if (!out.includes(sid)) out.push(sid);
	};
	scheduleIds.forEach((sid) => visitar(sid, 0));
	return out;
};

/** Lo que se manda para UN curso: su renglón, con el vínculo a otro curso de esta misma matrícula ya traducido. */
export const promoParaEnviar = (v: RequestPromotionDTO, sid: number, creadas: Record<number, number>, conReferido: boolean): RequestPromotionDTO => {
	const it: RequestPromotionItemDTO | undefined = (v.items || []).find((i) => i.scheduleId === sid);
	let item: any = it ? { ...it } : { scheduleId: sid, promotionId: null, inscriptionPromotionId: null, link: null };
	const l = item.link;
	if (l && l.type === "solicitud" && l.scheduleId && creadas[Number(l.scheduleId)]) {
		item = { ...item, link: { type: "matricula", enrollmentId: creadas[Number(l.scheduleId)] } };
	}
	return { items: [item], referredBy: conReferido ? (v.referredBy || null) : null, override10: v.override10 || null };
};

interface Props {
	campusId: number;
	studentId: number | null;
	studentName: string;
	scheduleIds: number[];
	value: RequestPromotionDTO;
	onChange: (v: RequestPromotionDTO) => void;
	busy: boolean;
	marcar: boolean;
}

const PromocionDirecta: React.FC<Props> = (p) => (
	<PasoPromocion campusId={p.campusId} requestId={null} studentId={p.studentId} studentName={p.studentName} scheduleIds={p.scheduleIds}
		value={p.value} onChange={p.onChange} busy={p.busy} marcar={p.marcar} bundle={[]} directa />
);

export default PromocionDirecta;
